import { DEFAULT_FALLBACK_LANGUAGE, type LanguageCode } from "config/languages";
import { getLocaleFromUrl } from "utils/getLocale";
import { getSlugWithoutLocale } from "utils/getSlugWithoutLocale";
import { getDefaultFolder, isDefaultLanguage } from "utils/isDefaultLanguage";
import { getParentLanguage } from "utils/localeUtils";

export const getResolvedDefaultHref = (href: string, language: LanguageCode) => {
  const locale = getLocaleFromUrl(href);
  const isDefaultLinkLocale = isDefaultLanguage(locale);

  if (isDefaultLinkLocale) {
    const slug = getSlugWithoutLocale(href);
    const isDefaultLanguage = getDefaultFolder(language);
    const parentLanguage = getParentLanguage(locale);

    const isSameDefault = parentLanguage === getParentLanguage(language);
    const fallbackLocale = locale === "en-default" ? DEFAULT_FALLBACK_LANGUAGE : parentLanguage;

    return isDefaultLanguage && isSameDefault ? `/${language}/${slug}` : `/${fallbackLocale}/${slug}`;
  }

  return href;
};
